import { Button, CloseButton, Drawer, Portal } from "@chakra-ui/react";
import { FC, useContext } from "react";
import { InfoDrawerContext } from "../../providers/InfoDrawer";
import Typhography from "../../shared/Typhography/Typhography";

export const InfoDrawer: FC = () => {
  const { state, setState } = useContext(InfoDrawerContext);

  const onClose = () => {
    setState(undefined);
  };
  const placement = state?.value?.placement || "end";
  return (
    <Drawer.Root
      open={!!state?.value}
      onInteractOutside={onClose}
      onEscapeKeyDown={onClose}
      placement={placement}
      size={state?.value?.size}
    >
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content
            roundedTop={placement === "bottom" ? "l3" : undefined}
            roundedBottom={placement === "top" ? "l3" : undefined}
          >
            <Drawer.Header>
              <Typhography size="bold-24">{state?.value?.title}</Typhography>
              {/* <Drawer.Title>{state?.value?.title}</Drawer.Title> */}
            </Drawer.Header>
            <Drawer.Body>
              {/* div (non Typhography=<p>): le guide iniettano div/section/p come
                  contenuto, che dentro un <p> darebbe validateDOMNesting. Stessa
                  classe di stile del testo regular-16. */}
              <div className="text-regular-16">{state?.value?.description}</div>
            </Drawer.Body>
            {/* <Drawer.Footer>
              <Drawer.ActionTrigger asChild>
                <Button variant="outline">Cancel</Button>
              </Drawer.ActionTrigger>
              <Button>Save</Button>
            </Drawer.Footer> */}
            <Drawer.CloseTrigger asChild onClick={onClose}>
              <CloseButton size="sm" />
            </Drawer.CloseTrigger>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};
